// TPP Core motion layer: scroll reveal for sections below the fold and the lime highlighter wipe.
// Presentation only. Respects prefers-reduced-motion; content is fully visible without JS.
(function () {
  if (window.__tppCore) return;
  window.__tppCore = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('tpp-js');

  // Highlighter: wipes in once the word is on screen.
  const hlObserver = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-lit');
      hlObserver.unobserve(e.target);
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('.overlay__style-highlight, .rte mark, .tpp-hl').forEach((el) => hlObserver.observe(el));

  // Reveal: sections that start below the fold fade up as they enter.
  const sections = [...document.querySelectorAll('#MainContent > .shopify-section')];
  const fold = window.innerHeight;
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      revealObserver.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  sections.forEach((section) => {
    if (section.getBoundingClientRect().top < fold) return;
    if (section.querySelector('[data-cc-animate], iframe, .swiper, [data-oke-widget]')) return;
    const inner = section.firstElementChild;
    if (!inner) return;
    inner.classList.add('tpp-rvl');
    revealObserver.observe(inner);
  });
})();

/* TPP Core card quick add: AJAX add, then open the Rebuy Smart Cart (same pattern as ct-product-cards.js).
   Any failure falls back to the native form post to /cart/add, so the button always works. */
(function () {
  if (window.__tppCardQuickAdd) return;
  window.__tppCardQuickAdd = true;
  // Click (capture) rather than submit: apps such as Rebuy hijack submit events on /cart/add forms and redirect.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('form[data-tpp-quick-add] .tpp-card__add');
    if (!button || !window.fetch) return;
    var form = button.form;
    event.preventDefault();
    event.stopPropagation();
    if (button.dataset.state === 'busy') return;
    button.dataset.state = 'busy';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: Number(form.elements.quantity.value) || 1 }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('add failed');
      button.dataset.state = 'done';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var rebuy = window.Rebuy;
      var open = function () {
        if (rebuy && rebuy.SmartCart && rebuy.SmartCart.show) { rebuy.SmartCart.show(); }
        else { window.location.href = root + 'cart'; }
      };
      if (rebuy && rebuy.Cart && rebuy.Cart.fetchCart) {
        Promise.resolve(rebuy.Cart.fetchCart()).then(open, open);
      } else { open(); }
      setTimeout(function () { delete button.dataset.state; }, 2000);
    }).catch(function () {
      delete button.dataset.state;
      form.submit();
    });
  }, true);
})();

/* Badge colour for cards rendered by script (e.g. "Shop the story"): same mapping as snippets/product-block.liquid. */
(function () {
  if (window.__tppBadges) return;
  window.__tppBadges = true;
  const key = (text) => {
    const t = text.toLowerCase();
    if (t.includes('entry')) return 'entry';
    if (t.includes('deep')) return 'deep';
    if (t.includes('vibe') || t.includes('vibrat')) return 'vibe';
    if (t.includes('discount') || t.includes('save') || t.includes('sale') || t.includes('%')) return 'save';
    return 'default';
  };
  const tag = (root) => root.querySelectorAll && root.querySelectorAll('.product-label:not([data-tpp-badge])').forEach((el) => { el.dataset.tppBadge = key(el.textContent || ''); });
  const run = () => {
    tag(document);
    new MutationObserver((records) => records.forEach((r) => r.addedNodes.forEach((n) => n.nodeType === 1 && tag(n)))).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
